export const myArticlesConstants = {
  TITLE_PLACEHOLDER: 'Headlines go here (good ones make readers want to know more)',
  SUBTITLE_PLACEHOLDER: 'Preview text (what the article is about; be short, punchy, informative)',
  COVER_IMAGES_CHOOSE_PLACEHOLDER: 'Choose a cover photo',
  COVER_IMAGES_NO_RESULTS: 'No results found for your search',
  COVER_IMAGES_NEXT_PAGE: 'Next Page',
  COVER_IMAGES_PREVIOUS_PAGE: 'Previous Page',
  COVER_IMAGES_MAX_PER_PAGE: 30,
  COVER_IMAGES_MAX_PAGE_COUNT: 2,
  UNSPLASH_URL: 'https://unsplash.com/',
  SUBMITTED_SUCCESS: 'Success! Your article has been submitted to our editorial team.',
  SUBMITTED_SUB_SUCCESS: "We'll notify you by email once it's published.",
  ARTICLE_CREATED_SUCCESS: 'Your new article was created successfully',
  ARTICLE_CREATED_FAIL: 'There was an error creating this article',
  ARTICLE_UPDATED_SUCCESS: 'The article was updated successfully',
  ARTICLE_UPDATED_FAIL: 'There was an error updating this article.',
  ARTICLE_SUBMITTED_FAIL: 'Failed to submit the article for publication',
  ARTICLE_LIST_FETCH_FAILURE: 'There was an error fetching the articles data.',
  ARTICLE_FETCH_FAILURE: 'There was an error fetching the article data.',
  ARTICLE_UPDATE_LAST_EDITED_DELAY: 60,
  COVER_IMAGE_WIDTH_DESKTOP: 750,
  COVER_IMAGE_WIDTH_MOBILE: 360,
};
export const articleAuthorModalConstants = {
  KEY: 'article-author-tip',
  TITLE: 'Write your first article',
  BODY: 'Get personal or give us the facts. Be relatable, but informative.',
  STEP_1: "Write your heart out — but, seriously, no rush. This isn't the LSAT.",
  STEP_2: 'Submit your article. Our editors will publish it or be in touch with feedback.',
  STEP_3: 'Get published, share, repeat.',
  LETS_GO: 'Let’s do this',
};
export const userArticlesTypes = {
  ALL: 'all',
  DRAFT: 'draft',
  PUBLISHED: 'published',
  REJECTED: 'rejected',
  SUBMITTED: 'submitted',
};
export const SUGGESTED_ARTICLE_IMAGE_SIZE = 200;
export const ARTICLE_PROGRAMS_THRESHOLD = 700;
